module.exports = __webpack_public_path__ + "img/air-china.2f8b0a7f.jpg";